import { useEffect } from "react";
import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { useZonesStore } from "@/store/zones/zones.store";
import { Zones } from "@/models/database/zones/Zones.model";

export const useTenantZones = (tenantId: string) => {
  const { zones, loading, error, setZones, setLoading, setError } =
    useZonesStore();

  const fetchZones = async () => {
    try {
      setLoading(true);
      const zonesArray: Zones[] = [];

      const ref = collectionRef.zones(tenantId);
      const query = await ref.get();
      query.docs.map(async (doc) => {
        zonesArray.push(doc.data() as Zones);
        return doc.data() as Zones;
      });

      setZones(zonesArray);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!zones) {
      fetchZones();
    }
  }, [tenantId]);

  return {
    data: zones,
    loading,
    error,
  };
};
